import { cva } from 'class-variance-authority'

export const flexClasses = cva('flex', {
  variants: {
    column: {
      true: 'flex-col',
      false: 'flex-row',
    },
    justify: {
      start: 'justify-start',
      end: 'justify-end',
      center: 'justify-center',
      between: 'justify-between',
      around: 'justify-around',
      evenly: 'justify-evenly',
    },
    items: {
      start: 'items-start',
      end: 'items-end',
      center: 'items-center',
      baseline: 'items-baseline',
      stretch: 'items-stretch',
    },
    self: {
      auto: 'self-auto	',
      start: 'self-start',
      end: 'self-end	',
      center: 'self-center	',
      stretch: 'self-stretch',
      baseline: 'self-baseline',
    },
    wrap: {
      none: 'flex-nowrap',
      wrap: 'flex-wrap',
      reverse: 'flex-wrap-reverse',
    },
    content: {
      start: 'content-start',
      end: 'content-end',
      center: 'content-center',
      between: 'content-between',
      around: 'content-around',
      evenly: 'content-evenly',
    },
    gapX: {
      0: 'gap-x-0',
      1: 'gap-x-1',
      2: 'gap-x-2',
      3: 'gap-x-3',
      4: 'gap-x-4',
      5: 'gap-x-5',
      6: 'gap-x-6',
      7: 'gap-x-7',
      8: 'gap-x-8',
      9: 'gap-x-9',
      10: 'gap-x-10',
      11: 'gap-x-11',
      12: 'gap-x-12',
      14: 'gap-x-14',
      16: 'gap-x-16',
      20: 'gap-x-20',
      24: 'gap-x-24',
      28: 'gap-x-28',
      32: 'gap-x-32',
      36: 'gap-x-36',
      40: 'gap-x-40',
      44: 'gap-x-44',
      48: 'gap-x-48',
      52: 'gap-x-52',
      56: 'gap-x-56',
      60: 'gap-x-60',
      64: 'gap-x-64',
      72: 'gap-x-72',
      80: 'gap-x-80',
      96: 'gap-x-96',
    },
    gapY: {
      0: 'gap-y-0',
      1: 'gap-y-1',
      2: 'gap-y-2',
      3: 'gap-y-3',
      4: 'gap-y-4',
      5: 'gap-y-5',
      6: 'gap-y-6',
      7: 'gap-y-7',
      8: 'gap-y-8',
      9: 'gap-y-9',
      10: 'gap-y-10',
      11: 'gap-y-11',
      12: 'gap-y-12',
      14: 'gap-y-14',
      16: 'gap-y-16',
      20: 'gap-y-20',
      24: 'gap-y-24',
      28: 'gap-y-28',
      32: 'gap-y-32',
      36: 'gap-y-36',
      40: 'gap-y-40',
      44: 'gap-y-44',
      48: 'gap-y-48',
      52: 'gap-y-52',
      56: 'gap-y-56',
      60: 'gap-y-60',
      64: 'gap-y-64',
      72: 'gap-y-72',
      80: 'gap-y-80',
      96: 'gap-y-96',
    },
    grow: {
      false: 'flex-grow-0',
      true: 'flex-grow',
    },
    shrink: {
      false: 'flex-shrink-0',
      true: 'flex-shrink',
    },
  },
})
